var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18C8.51664 18 7.06659 17.5601 5.83323 16.736C4.59986 15.9119 3.63856 14.7406 3.07091 13.3701C2.50325 11.9997 2.35472 10.4917 2.64411 9.03683C2.9335 7.58197 3.64781 6.2456 4.6967 5.1967C5.7456 4.14781 7.08197 3.4335 8.53683 3.14411C9.99168 2.85472 11.4997 3.00325 12.8701 3.57091C14.2406 4.13856 15.4119 5.09986 16.236 6.33323C17.0601 7.56659 17.5 9.01664 17.5 10.5C17.4979 12.4885 16.707 14.3949 15.3009 15.8009C13.8949 17.207 11.9885 17.9979 10 18ZM10 4.25C8.76387 4.25 7.5555 4.61656 6.52769 5.30332C5.49988 5.99008 4.6988 6.96619 4.22576 8.10823C3.75271 9.25027 3.62894 10.5069 3.8701 11.7193C4.11125 12.9317 4.70651 14.0453 5.58059 14.9194C6.45466 15.7935 7.56831 16.3888 8.78069 16.6299C9.99307 16.8711 11.2497 16.7473 12.3918 16.2742C13.5338 15.8012 14.5099 15.0001 15.1967 13.9723C15.8834 12.9445 16.25 11.7361 16.25 10.5C16.2482 8.84296 15.5891 7.2543 14.4174 6.0826C13.2457 4.91089 11.657 4.25182 10 4.25Z",
    fill: "#E95D05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 14.875H10V10.5H8.75V9.25H10C10.3315 9.25 10.6495 9.3817 10.8839 9.61612C11.1183 9.85054 11.25 10.1685 11.25 10.5V14.875Z",
    fill: "#E95D05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8C10.5178 8 10.9375 7.58027 10.9375 7.0625C10.9375 6.54473 10.5178 6.125 10 6.125C9.48223 6.125 9.0625 6.54473 9.0625 7.0625C9.0625 7.58027 9.48223 8 10 8Z",
    fill: "#E95D05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconSmall);
export default __webpack_public_path__ + "static/media/info-icon-small.9a78358e2c026b36de2fad800af66069.svg";
export { ForwardRef as ReactComponent };